import React, { useState } from "react";
import styled from "styled-components";
import { Col, Form } from "react-bootstrap";
import { isChenoa } from "../Utils/WHL/helpers";
import HTMLReactParser from "html-react-parser";

const StyleWrapper = styled.div`
.consentDesc p::before{
  display: ${props => props.showConsent ? 'block' : 'none'};
}

.consent-title {
  cursor: pointer;
}

.consent-title:hover {
  color: #00aae4;
}
.consent-toggle {
  text-decoration: none;
}

.consent-toggle:hover {
  text-decoration: underline;
}

.checkboxConsent label{
    line-height: 1 !important;
    text-align: left;
    display: block;
    margin-bottom: 3px;
    margin-top: 3px;
    font-size: 11px;
    margin-left: 20px;
}

.checkboxConsent .form-check {
        padding-left: 0 !important;
        margin-top: 15px;
}

.checkboxConsent .form-check-input{
    margin-left: 0 !important;
    left: 0;
    cursor: pointer;
}

.checkboxConsent.consent-text {
    display: flex;
    align-items: center;
    margin-top: 0
}

.form-check-input {
    width: 15px;
    height: 15px;
}

.checkboxConsent.consent-text.form-check .invalid-feedback,
.checkboxConsent.consent-text.form-check .valid-feedback {
    display:none;
}

@media screen and (max-width: 699px) {
    .checkboxConsent label {
        line-height: 1.5 !important;
    }

    .form-check{
        margin-top: 5px !important;
    }

    .form-check-input {
        width: 15px
        height: 15px
    }
}
`;

export const Consent = ({ agreed, handleConsentClick, consentData }) => {
  const [showConsent, setShowConsent] = useState(false);

  const toggleConsent = () => {
    setShowConsent(!showConsent);
  };

  return (
    <StyleWrapper showConsent={showConsent}>
      <div className="consentDesc">
        <p className="consent-title">
          <strong onClick={toggleConsent}>
            Do you consent to Automated Phone Solicitation?{" "}
            <span className="consent-toggle" title={showConsent ? "Hide Phone Solicitation Consent" : "Show Phone Solicitation Consent"}>
              {showConsent ? "(click to show less)" : "(click to show more)"}
            </span>
          </strong>
        </p>

        {showConsent && (
          <p className="m-0 consent-desc" id="consent-desc-id">
            {consentData?.automatedPhoneSolicitationConsent && (
              <>
                {HTMLReactParser(consentData.automatedPhoneSolicitationConsent.content)}
              </>
            )}

          </p>
        )}
        <div>
          <Form.Row className="consent-chkbox-row">
            <Col className="px-0 ideal-input" xl={3} lg={3} md={4} sm={4} xs={4}>
              <Form.Group
                className="consent-grp"
                controlId="consentChkBox"
                onClick={(e) => handleConsentClick(e, true)}
              >
                <Form.Check
                  type="checkbox"
                  label="I Consent"
                  data-type="agree"
                  value={agreed}
                  checked={agreed}
                />
              </Form.Group>
            </Col>
            <Col className="px-0" xl={5} lg={5} md={5} sm={6} xs={6}>
              <Form.Group
                className="consent-grp"
                controlId="consentFalseChkBox"
                onClick={(e) => handleConsentClick(e, false)}
              >
                <Form.Check
                  type="checkbox"
                  label="I DO NOT Consent"
                  data-type="disagree"
                  checked={agreed === false}
                  value={!agreed}
                />
              </Form.Group>
            </Col>
          </Form.Row>
        </div>

      </div>
    </StyleWrapper>
  );
};

export default Consent;